import React from 'react'
import { BrowserRouter, Redirect, Route } from 'react-router-dom'

import CabecalhoSistema from '../cabecalhoSistema'
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs'
import clickstreamAnalise from '../components/clickstreamAnalise/clickstreamAnalise.js'
import '../components/clickstreamAnalise/clickstreamColeta.js'
import TelaLogin from '../components/login/login'
import logout from '../components/logout/logout'
import TabelaAcessoLog from '../components/painelAdministrativo/logs/acessoLog/tabela'
import TabelaImeiLog from '../components/painelAdministrativo/logs/imeiLog/tabela'
import TabelaRequestLog from '../components/painelAdministrativo/logs/requestLog/tabela'
import TabelaCliente from '../components/painelAdministrativo/pavCliente/tabela'
import TabelaCrudRBAC from '../components/painelAdministrativo/pavCrudRBAC/tabela'
import TabelaElemento from '../components/painelAdministrativo/pavElemento/tabela'
import TabelaGit from '../components/painelAdministrativo/pavGit/tabela'
import TabelaMenu from '../components/painelAdministrativo/pavMenu/tabela'
import TabelaModulo from '../components/painelAdministrativo/pavModulo/tabela'
import TabelaParceiro from '../components/painelAdministrativo/pavParceiro/tabela'
import TabelaPerfil from '../components/painelAdministrativo/pavPerfil/tabela'
import CadastroPermissao from '../components/painelAdministrativo/pavPermissao/cadastro'
import TabelaSistema from '../components/painelAdministrativo/pavSistema/tabela'
import TabelaTela from '../components/painelAdministrativo/pavTela/tabela'
import TabelaUsuario from '../components/painelAdministrativo/pavUsuario/tabela'
import TabelaVersionamento from '../components/painelAdministrativo/pavVersionamento/tabela'
import TabelaAutomacao from '../components/painelAutomacao/tabelaAutomacao'
import PainelCadastroCliente from '../components/painelCadastros/cadCliente/tabela'
import TabelaCadastroPerfil from '../components/painelCadastros/perfil/tabela'
import DashboardGeral from '../components/painelDashboard/dashboard'
import DashboardSMS from '../components/painelDashboard/dashboardsms'
import DashboardPortadoras from '../components/painelDashboard/Portadoras'
import TabelaDispositivos from '../components/painelDispositivos/dspSimcard/tabelaSimcard'
import TabelaConectSolicitacoes from '../components/painelFaturas/conectSolicitacoes/tabela'
import FaturasCadastroCicloVida from '../components/painelFaturas/fatCicloVida/tabela'
import FatConciliacao from '../components/painelFaturas/fatConciliacao/tabela'
import FaturasCadastroContas from '../components/painelFaturas/fatContas/tabela'
import FatContestacao from '../components/painelFaturas/fatContestacao/tabela'
import DashboardFaturas from '../components/painelFaturas/fatDashboard/dashboard'
import TabelaDispostiviosFaturas from '../components/painelFaturas/fatDispositivos/tabela'
import FaturasCadastroEmpresas from '../components/painelFaturas/fatEmpresas/tabela'
import FatFaturas from '../components/painelFaturas/fatFaturas/tabela'
import FatTabelaFebraban from '../components/painelFaturas/fatFebraban/tabela'
import FatTabelaFornecedores from '../components/painelFaturas/fatFornecedores/tabela'
import FatTabelaOperadoras from '../components/painelFaturas/fatOperadoras/tabela'
import FaturasPedidos from '../components/painelFaturas/fatPedidos/tabela'
import FatTabelaPlanos from '../components/painelFaturas/fatPlanos/tabela'
import FatRelatorios from '../components/painelFaturas/fatRelatorios/tabela'
import FatTabelaServico from '../components/painelFaturas/fatServico/tabela'
import TabelaFatSolicitacoes from '../components/painelFaturas/fatSolicitacoes/tabela'
import trial from '../components/painelFaturas/fatTrial/trial'
import TabelaFinanceiro from '../components/painelFinanceiro/tabela'
import TabelaMensagens from '../components/painelMensagens/tabela'
import TabelaSimcardPedidos from '../components/painelPedidos/pedidosSimcard/tabela'
import TabelaNovoPedidoSms from '../components/painelPedidos/pedidosSms/tabela'
import PainelRelatorio from '../components/painelRelatorio/tabela'
import TabelaLinhasRestTrucks from '../components/painelResetTrucks/tabela'
import TabelaMensagensSms from '../components/painelSms/smsMensagens/tabela'
import TabelaTemplateSms from '../components/painelSms/smsTemplate/tabela'
import PainelTutoriais from '../components/painelTutoriais/painelTutoriais'
import TabelaUsuarioCliente from '../components/painelUsuarios/tabela'
import TabelaCentralMensagens from '../components/painelVirtueyes/centralMensagens/tabela'
import MigracaoPlanoDashboard from '../components/painelVirtueyes/migracaoPlano/dashboard/index.js'
import MigracaoPlanoGerenciamento from '../components/painelVirtueyes/migracaoPlano/tabela'
import TabelaPedidoSmS from '../components/painelVirtueyes/pedidoSms/tabelaPedidoSms'
import TabelaBloqueioAcoes from '../components/painelVirtueyes/solicitacaoBloqueio/tabela'
import TabelaClientesAcoes from '../components/painelVirtueyes/solicitacaoCliente/tabela'
import TabelaOperadoraAcoes from '../components/painelVirtueyes/solicitacaoOperadora/tabela'
import TabelaClientes from '../components/painelVirtueyes/virtuTabelaClientes/tabelaClientes'
import TelaInicial from '../components/telaInicial/telaInicial'
import NavegacaoSistema from '../navegacaoSistema'
import ActivationSimcard from '../pages/demo/expoSec.jsx'
import LoginActivation from '../pages/demo/loginActivation.jsx'
// import ESimDevices from '../pages/eSims/devices.jsx'
// import ESimsStock from '../pages/eSims/stock.jsx'
import TabelaPortadoras from '../pages/portadoras'
import TabelaSimcardsVirgens from '../pages/simcards-virgens/index.jsx'
// import TabelaESims from '../pages/solicitacoes/e-sims/index.jsx'
import SimcardsVirgensSolicitacoes from '../pages/solicitacoes/simcards-virgens/index.jsx'
import routers from '../statics/routers.json'
import { ResetOnRouteChange } from '../utils/ResetOnRouteChange.jsx'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const hasToken = localStorage.getItem('@veye-Token')

  return (
    <Route
      exact
      {...rest}
      render={(props) =>
        hasToken ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: routers.login, state: { from: props.location } }}
          />
        )
      }
    />
  )
}

export default function Routers() {
  return (
    <BrowserRouter>
      <ResetOnRouteChange />
      <Route
        path={routers.login}
        exact
        render={() => {
          const hasToken = localStorage.getItem('@veye-Token')
          return hasToken ? <Redirect to="/veye" /> : <TelaLogin />
        }}
      />
      <Route path="/" exact>
        <Redirect from="/" to={routers.telaInicial} />
      </Route>
      <Route path={routers.logout} exact component={logout} />
      <Route path={routers.trial} component={trial} />
      <Route
        path={routers.demo.activationSimcard}
        component={ActivationSimcard}
      />
      <Route path={routers.demo.loginActivation} component={LoginActivation} />
      <Route
        path={routers.telaInicial}
        render={() =>
          localStorage.getItem('@veye-Token') ? (
            <>
              <NavegacaoSistema />
              <div id="container-tela">
                <CabecalhoSistema />
                <div id="container-corpo">
                  <BreadCrumbs />
                  <PrivateRoute
                    path={routers.telaInicial}
                    component={TelaInicial}
                  />
                  <PrivateRoute
                    path={routers.dispositivos}
                    component={TabelaDispositivos}
                  />
                  <PrivateRoute
                    path={routers.painelSistema}
                    component={TabelaSistema}
                  />
                  <PrivateRoute
                    path={routers.painelModulo}
                    component={TabelaModulo}
                  />
                  <PrivateRoute
                    path={routers.painelTela}
                    component={TabelaTela}
                  />
                  <PrivateRoute
                    path={routers.painelElemento}
                    component={TabelaElemento}
                  />
                  <PrivateRoute
                    path={routers.painelUsuarios}
                    component={TabelaUsuario}
                  />
                  <PrivateRoute
                    path={routers.tabelaVersoes}
                    component={TabelaVersionamento}
                  />
                  <PrivateRoute
                    path={routers.painelVersionamento}
                    component={TabelaVersionamento}
                  />
                  <PrivateRoute
                    path={routers.painelGit}
                    component={TabelaGit}
                  />
                  <PrivateRoute
                    path={routers.painelClientes}
                    component={TabelaCliente}
                  />
                  <PrivateRoute
                    path={routers.painelParceiros}
                    component={TabelaParceiro}
                  />
                  <PrivateRoute
                    path={routers.painelPapeis}
                    component={TabelaCrudRBAC}
                  />
                  <PrivateRoute
                    path={routers.painelPerfil}
                    component={TabelaPerfil}
                  />
                  <PrivateRoute
                    path={routers.painelRequestLog}
                    component={TabelaRequestLog}
                  />
                  <PrivateRoute
                    path={routers.painelAcessoLog}
                    component={TabelaAcessoLog}
                  />
                  <PrivateRoute
                    path={routers.painelPermissoes}
                    component={CadastroPermissao}
                  />
                  <PrivateRoute
                    path={routers.painelClickstreamAnalise}
                    component={clickstreamAnalise}
                  />
                  <PrivateRoute
                    path={routers.virtueyesClientes}
                    component={TabelaClientes}
                  />
                  <PrivateRoute
                    path={routers.virtueyesCentralMensagens}
                    component={TabelaCentralMensagens}
                  />
                  <PrivateRoute
                    path={routers.virtueyesPedidosSMS}
                    component={TabelaPedidoSmS}
                  />
                  <PrivateRoute
                    path={routers.virtueyesMigracaoPlanoGerenciamento}
                    component={MigracaoPlanoGerenciamento}
                  />
                  <PrivateRoute
                    path={routers.virtueyesMigracaoPlanoDashboard}
                    component={MigracaoPlanoDashboard}
                  />
                  <PrivateRoute
                    path={routers.virtueyesClientesAcoes}
                    component={TabelaClientesAcoes}
                  />
                  <PrivateRoute
                    path={routers.virtueyesOperadoraAcoes}
                    component={TabelaOperadoraAcoes}
                  />
                  <PrivateRoute
                    path={routers.virtueyesBloqueioAcoes}
                    component={TabelaBloqueioAcoes}
                  />
                  <PrivateRoute
                    path={routers.smsMensagens}
                    component={TabelaMensagensSms}
                  />
                  <PrivateRoute
                    path={routers.smsTemplate}
                    component={TabelaTemplateSms}
                  />
                  <PrivateRoute
                    path={routers.pedidosSms}
                    component={TabelaNovoPedidoSms}
                  />
                  <PrivateRoute
                    path={routers.pedidosSimcard}
                    component={TabelaSimcardPedidos}
                  />
                  <PrivateRoute
                    path={routers.financeiro}
                    component={TabelaFinanceiro}
                  />
                  <PrivateRoute
                    path={routers.dashboardDispositivos}
                    component={DashboardGeral}
                  />
                  <PrivateRoute
                    path={routers.dashboardSMS}
                    component={DashboardSMS}
                  />
                  <PrivateRoute
                    path={routers.dashboardPortadoras}
                    component={DashboardPortadoras}
                  />
                  <PrivateRoute
                    path={routers.automacao}
                    component={TabelaAutomacao}
                  />
                  <PrivateRoute
                    path={routers.tutoriais}
                    component={PainelTutoriais}
                  />
                  <PrivateRoute
                    path={routers.mensagens}
                    component={TabelaMensagens}
                  />
                  <PrivateRoute
                    path={routers.usuarios}
                    component={TabelaUsuarioCliente}
                  />
                  <PrivateRoute
                    path={routers.faturasPedidos}
                    component={FaturasPedidos}
                  />
                  <PrivateRoute
                    path={routers.faturasContas}
                    component={FaturasCadastroContas}
                  />
                  <PrivateRoute
                    path={routers.faturasFebraban}
                    component={FatTabelaFebraban}
                  />
                  <PrivateRoute
                    path={routers.faturasEmpresas}
                    component={FaturasCadastroEmpresas}
                  />
                  <PrivateRoute
                    path={routers.faturasPlanos}
                    component={FatTabelaPlanos}
                  />
                  <PrivateRoute
                    path={routers.faturasServicos}
                    component={FatTabelaServico}
                  />
                  <PrivateRoute
                    path={routers.faturasCicloVida}
                    component={FaturasCadastroCicloVida}
                  />
                  <PrivateRoute
                    path={routers.faturasOperadoras}
                    component={FatTabelaOperadoras}
                  />
                  <PrivateRoute
                    path={routers.solicitacoesFaturas}
                    component={TabelaFatSolicitacoes}
                  />
                  <PrivateRoute
                    path={routers.solicitacoesSimcardsEmBranco}
                    component={SimcardsVirgensSolicitacoes}
                  />

                  <PrivateRoute
                    path={routers.solicitacoesConectividade}
                    component={TabelaConectSolicitacoes}
                  />
                  <PrivateRoute
                    path={routers.faturasDispositivos}
                    component={TabelaDispostiviosFaturas}
                  />
                  <PrivateRoute
                    path={routers.faturasFornecedores}
                    component={FatTabelaFornecedores}
                  />
                  <PrivateRoute
                    path={routers.faturasFaturas}
                    component={FatFaturas}
                  />
                  <PrivateRoute
                    path={routers.faturasConciliacao}
                    component={FatConciliacao}
                  />
                  <PrivateRoute
                    path={routers.faturasContestacao}
                    component={FatContestacao}
                  />
                  <PrivateRoute
                    path={routers.faturasDashboard}
                    component={DashboardFaturas}
                  />
                  <PrivateRoute
                    path={routers.faturasRelatorios}
                    component={FatRelatorios}
                  />
                  <PrivateRoute
                    path={routers.painelRelatorios}
                    component={PainelRelatorio}
                  />
                  <PrivateRoute
                    path={routers.painelImeiLog}
                    component={TabelaImeiLog}
                  />
                  <PrivateRoute
                    path={routers.painelMenu}
                    component={TabelaMenu}
                  />
                  <PrivateRoute
                    path={routers.cadastroPerfil}
                    component={TabelaCadastroPerfil}
                  />
                  <PrivateRoute
                    path={routers.cadastroCliente}
                    component={PainelCadastroCliente}
                  />
                  <PrivateRoute
                    path={routers.portalCliente}
                    component={PainelCadastroCliente}
                  />
                  <PrivateRoute
                    path={routers.linhasReset}
                    component={TabelaLinhasRestTrucks}
                  />
                  <PrivateRoute
                    path={routers.simcardsEmBranco}
                    component={TabelaSimcardsVirgens}
                  />
                  <PrivateRoute
                    path={routers.portadoras}
                    component={TabelaPortadoras}
                  />
                  {/* <PrivateRoute
                    path={routers.solicitacoesESims}
                    component={TabelaESims}
                  />
                  <PrivateRoute
                    path={routers.eSimDevices}
                    component={ESimDevices}
                  />
                  <PrivateRoute
                    path={routers.eSimStock}
                    component={ESimsStock}
                  /> */}
                </div>
              </div>
            </>
          ) : (
            <Redirect to={{ pathname: '/login' }} />
          )
        }
      />
    </BrowserRouter>
  )
}
